import * as React from 'react';

import { cn } from '@/lib/utils';

type NoticeTone = 'destructive' | 'success' | 'warning' | 'info';

const toneClasses: Record<NoticeTone, string> = {
  destructive: 'border-destructive-border bg-destructive-subtle text-destructive',
  success: 'border-success-border bg-success-subtle text-success',
  warning: 'border-warning-border bg-warning-subtle text-warning',
  info: 'border-info-border bg-info-subtle text-info',
};

interface NoticeProps extends React.HTMLAttributes<HTMLDivElement> {
  tone: NoticeTone;
}

export function Notice({ tone, className, ...props }: NoticeProps) {
  return (
    <div
      role={tone === 'destructive' ? 'alert' : 'status'}
      className={cn('rounded-md border px-3 py-2 text-sm', toneClasses[tone], className)}
      {...props}
    />
  );
}
